import { OrganizationCapabilityPlan } from '@core/models/organization-capability-plan.model';
import { OrganizationEntitlement } from '@core/models/organization-entitlement.model';
import { Organization } from 'app/modules/organizations-manager/models/organization.model';

export const SHARED_STATE_ACTION_PREFIX = '[Cost State]';

export class SetSpinner {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Set Spinner`;
  constructor(
    public isEnable: boolean,
    public message?: string
  ) {}
}

export class ResetSharedState {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Reset State`;
}

export class SetOrganization {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Set Organization`;
  constructor(public organization: Organization) {}
}

export class FetchOrganization {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Fetch Organization`;
  constructor(public orgId: string) {}
}

export class LoadOrganizationEntitlementsCapabilityData {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Load Organization Entitlements and Capability Data`;
  constructor(public orgId: string) {}
}

export class SetOrganizationEntitlementsCapabilityData {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Set Organization Entitlements and Capability Data`;
  constructor(
    public orgEntitlements: OrganizationEntitlement[],
    public organizationCapabilityPlan: OrganizationCapabilityPlan
  ) {}
}
